import React, { Component } from 'react';
import Table1 from "./7-1-1PayrollCostByLevel";
import Table2 from "./7-1-2Payroll-Cost-By-Department";
import Table3 from "./7-1-3";
import { Row } from "antd";
class index extends Component {
    render() {
        return (
            <div>
                <Row style={{ margin: "24px 0 24px 24px", fontSize: 22, color: "#333" }}>
                    7.1 Total Payroll Cost Analysis 薪酬总成本分析
                </Row>
                <Table1 {...this.props} />
                <Table2 {...this.props} />
                <Table3 />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-1TotalPayrollCostAnalysis/index.js